export enum InvoiceDiscountLocation {
  PerLine = 'perLine',
  PerTotal = 'perTotal',
}
